import React from "react"; 
import { NavLink } from "react-router-dom";
export class CasinoMaratonMyData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isJokerUsed:null,
        }
    }

    dateWithoutTime(date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }

    componentDidMount() {
        casino.repos.casinoBonusMaratonRepo.rezultatiIgrac(this.props.player.igracID).then((res) => {
            let isUsed = res.find(it => new Date(it.datumDan).getTime() != this.dateWithoutTime(new Date()).getTime() && it.igraSifra == null);
            this.setState(
                { 
                    isJokerUsed : isUsed != null
                });
        });
    }

    isMaratonFinished() {
        return new Date().getTime() > new Date(this.props.info.aktivnoDo).getTime();
    }

    getPlayerReward() {
        if (!this.props.player) return 0;
        let reward = this.props.finalResults.find(it => it.igracID == this.props.player.igracID);
        return reward ? reward.nagrada : 0;
    }

    scrollToGames() {
        document.querySelector('#tabs').scrollIntoView({
            behavior: 'smooth'
        });
    }

    render() {
        return (
            <div className="casino-maraton-section">
                <h2>Moji podaci</h2>    
                <div className="my-data">
                    <span className="place">
                        <span className="image">
                            <div className="data">
                                <div>{this.props.player?.ordinalNumber}.</div>
                                <div>mjesto</div>
                            </div>
                        </span>                     
                    </span>
                    {!this.isMaratonFinished() && <span className="points">
                        <span className="image">
                            <div className="data">
                                <div>{this.props.player?.pointsToday}</div>
                                <div>bodova danas</div>
                            </div>
                        </span>
                    </span>}
                    <span className="points-total">
                        <span className="image">
                            <div className="data">
                                <div>{this.props.player?.points}</div>
                                <div>bodova ukupno</div>
                            </div>
                        </span>                  
                    </span>
                    {this.props?.info.joker == true && <span className="joker">
                        <span className="image">
                            <div className="data">
                                <div>Joker</div>
                                {!this.state.isJokerUsed && <div>nije iskorišten</div>}
                                {this.state.isJokerUsed && <div>je iskorišten</div>}
                            </div>
                            <span className={this.state.isJokerUsed ? "icon red" : "icon green"}></span>
                        </span>
                    </span>}
                </div> 
                {!this.props?.info.uplaceno && 
                    <div className="possible-win">
                        Garantirani dobitak: <span className="red">{casino.utils.numberWithCurrencyFromated(40000 / this.props.activePlayers , 'EUR')}</span>
                    </div>
                }

                {!this.isMaratonFinished() && this.props?.player.pointsToday == 0 &&
                    <div className="status">
                        {/* <div className="icon yellow"></div> */}
                        <div className="message">Danas još nisi sudjelovao u maratonu!</div>
                        <button className="btn" onClick={() => this.scrollToGames()}>Zaigraj</button>
                    </div>
                }
                 {!this.isMaratonFinished() && this.props?.player.pointsToday > 0 &&
                    <div className="status">
                       {/* <div className="icon green"></div> */}
                       <div className="message">I dalje sudjeluješ u maratonu! Bravo!</div>
                        <button className="btn" onClick={() => this.scrollToGames()}>Zaigraj</button>
                    </div>
                }

                {this.isMaratonFinished()  &&
                    <div className="status">
                        {/* <div className="icon green"></div> */}
                        <div className="message">Casino maraton je završen 💪👟</div>
                        {this.getPlayerReward() > 0 && <div className="reward-payout">Isplaćeno ti je: <span style={{ color: '#aa0d19' }}> {casino.utils.numberWithCurrencyFromated(this.getPlayerReward(), this.props.info.valuta)}</span></div>}
                    </div>
                }
                
                <div className="divider"></div>      
            </div>
        );
    }
}